import DatePick_MI from 'components/DatePicker_MI'
import React, { useContext, useState, useEffect } from 'react'
import { RadioButtonsRow } from '../5_VehicleLeasedFinanced/RadioButtonsRow/RadioButtonsRow'

const VehiclePurchased = ({ requestContext, vehicleContext, endorsementClassStr, endorsementSetClassStr }) => {
    const requestTypeContext = useContext(requestContext)
    const newVehicleContext = useContext(vehicleContext)
    const oldPurchaseDate = "01/01/1000";
    const [datePurchased, setDatePurchased] = useState("");
    const [purchasedRecently,setPurchasedRecently] = useState(newVehicleContext.newVehicle.datePurchased == ""?"":newVehicleContext.newVehicle.datePurchased == oldPurchaseDate ? "0":"1");
    const [isMobile, setIsMobile] = useState(window.innerWidth < 576);
    const updatePurchasedDate = (value) => {
        setPurchasedRecently(value);
        if(value == 1 && (datePurchased == ""|| datePurchased === oldPurchaseDate)){
            setDatePurchased("")
            newVehicleContext.setNewVehicle({
                ...newVehicleContext.newVehicle,
                datePurchased: null
            });
        }
        else if(value == 0){
            setDatePurchased(oldPurchaseDate)
            newVehicleContext.setNewVehicle({
                ...newVehicleContext.newVehicle,
                datePurchased: oldPurchaseDate
            });
        }
    }

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 576);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Updates the value for the new vehicle and component tracker
    const updateVehicle = (key, value) => {
        var vehicleCopy = newVehicleContext.initialVehicle
        resetVehicleInfo(vehicleCopy, value)

        var vehicleClassCopy = requestTypeContext[endorsementClassStr]
        vehicleClassCopy.vehicles.vehiclesOnPolicy.newVehicles[0] = vehicleCopy
        requestTypeContext[endorsementSetClassStr]({ ...vehicleClassCopy });
    }

    // Clears old values (if exists) for new form
    const resetVehicleInfo = (vehicleCopy, value) => {
        vehicleCopy.componentTracker = (value == "Owned" ? "VehicleOwned" : value == "Leased" ? "VehicleLeased" : "VehicleFinanced")
        vehicleCopy.requestedCovEffDate = newVehicleContext.newVehicle.requestedCovEffDate
        vehicleCopy.datePurchased = newVehicleContext.newVehicle.datePurchased
        vehicleCopy.vehicleBody = newVehicleContext.newVehicle.vehicleBody
        vehicleCopy.vehicleMake = newVehicleContext.newVehicle.vehicleMake
        vehicleCopy.vehicleModel = newVehicleContext.newVehicle.vehicleModel
        vehicleCopy.vehicleYear = newVehicleContext.newVehicle.vehicleYear
        vehicleCopy.vehicleVIN = newVehicleContext.newVehicle.vehicleVIN
        vehicleCopy.vehicleOwnedLeasedFinanced = value
        newVehicleContext.setNewVehicle({ ...vehicleCopy });
    }

    return (
        <>
            <hr />
            <div className='col-xl-12 justify-content-center' style={{ margin: "0 0.5rem", padding: "0 0.75rem" }}>
                {/* Date Purchased */}
                <RadioButtonsRow
                name="purchasedRecently"
                    question={
                    <>Was this vehicle purchased in the last 12 <span style={{whiteSpace:"nowrap"}}>months?*</span></>
                    }
                    value={purchasedRecently}
                    onChange={(e) => updatePurchasedDate(e.target.value)}
                />
                {purchasedRecently == 1 &&
                <div className='row form-group form-group-sm align-items-center my-3'>
                    <div className="col-12 col-md-6 text-primary fw-bold mb-2 mb-md-0 fs-6">
                        Date Purchased*
                    </div>
                    <div className={isMobile?"col-12 col-md-6 col-sm-8":"col-3 col-xl-3 col-lg-4 col-md-4 col-sm-5"}>
                        <DatePick_MI
                            dateSubmit={newVehicleContext.newVehicle.datePurchased ? newVehicleContext.newVehicle.datePurchased : datePurchased}
                            setDateSubmit={setDatePurchased}
                            storeValue={newVehicleContext.newVehCallback}
                            nameValue={"datePurchased"}
                            setToday={true}
                            displayCalendar={"bottom-start"}
                            set1Year={true}
                        />
                    </div>
                </div>
                }
                {/* Vehicle Owned/Leased/Financed */}
                <div className='row form-group form-group-sm align-items-center my-3'>
                    <div className="col-12 col-md-6 text-primary fw-bold mb-2 mb-md-0 fs-6">
                        Is this vehicle owned, leased, or financed?*
                    </div>
                    <div className="col-12 col-md-6 col-sm-8">
                        <select className="col-sm-12 btn btn-default btn-group dropdown-toggle filter-option mt-1"
                            value={newVehicleContext.newVehicle.vehicleOwnedLeasedFinanced}
                            onChange={(e) => { updateVehicle("vehicleOwnedLeasedFinanced", e.target.value) }}>
                            <option value={""} disabled>Select from the following...</option>
                            <option value="Owned">Owned</option>
                            <option value="Leased">Leased</option>
                            <option value="Financed">Financed</option>
                        </select>
                    </div>
                </div>
            </div>
        </>
    )
}

export default VehiclePurchased